module.exports = __webpack_public_path__ + "static/Attom-ec86c348725bd2bb7f46154f0aa8e1d8.png";